import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PermissionRecord } from "../../api/permissionMatrix";

interface PermissionState {
  permissions: PermissionRecord[]; // All permissions fetched from API
  role: string;
  userId: string;
}

const initialState: PermissionState = {
  permissions: [],
  role: "",
  userId: "",
};

const permissionSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setPermissions: (state, action: PayloadAction<PermissionRecord[]>) => {
      state.permissions = action.payload;
    },
    setRoleAndUser: (state, action: PayloadAction<{ role: string; userId: string }>) => {
      state.role = action.payload.role;
      state.userId = action.payload.userId;
    },
    resetPermissions: () => initialState,
  },
});

export const { setPermissions, setRoleAndUser, resetPermissions } = permissionSlice.actions;
export default permissionSlice.reducer;
